import { ICellRendererParams } from "ag-grid-community";
import { FC } from "react";
import useFilterModelHighlightHTML from "./useFilterModelHighlightHTML";
import { classHOC } from "./ClassWrapper";

// wait to refactor - replace with HighlightCellRenderer
const HighlightFilterModelCellRenderer: FC<ICellRendererParams> = ({ value, api, node }) => {
  const html = useFilterModelHighlightHTML(api, value);
  if (node.rowPinned) return null;
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
};

export default classHOC(HighlightFilterModelCellRenderer);
